var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "calculate-price__form-section" }, [
      _c("h2", { staticClass: "calculate-price__form-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.dependant_leave_area
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "grid grid-cols-1 lg:grid-cols-3 gap-x-5 gap-y-5 lg:gap-y-8 items-end"
        },
        [
          _c(
            "div",
            [
              _c(
                "theme-numeric",
                {
                  attrs: {
                    name: "leaveArea[own_room][surface]",
                    label:
                      _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.private_rooms_surface,
                    IsExtraInfo: true
                  },
                  on: {
                    input: function($event) {
                      return _vm.countDependantLeaveAreaPoints(_vm.leaveArea)
                    }
                  },
                  model: {
                    value: _vm.leaveArea["own_room"].surface,
                    callback: function($$v) {
                      _vm.$set(_vm.leaveArea["own_room"], "surface", $$v)
                    },
                    expression: "leaveArea['own_room'].surface"
                  }
                },
                [
                  _c("template", { slot: "extra-info" }, [
                    _vm._v(" m"),
                    _c("sup", [_vm._v("2")])
                  ])
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "theme-numeric",
                {
                  attrs: {
                    name: "leaveArea[common_area][surface]",
                    label:
                      _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.common_area_at_same_address,
                    IsExtraInfo: true
                  },
                  on: {
                    input: function($event) {
                      return _vm.countDependantLeaveAreaPoints(_vm.leaveArea)
                    }
                  },
                  model: {
                    value: _vm.leaveArea["common_area"].surface,
                    callback: function($$v) {
                      _vm.$set(_vm.leaveArea["common_area"], "surface", $$v)
                    },
                    expression: "leaveArea['common_area'].surface"
                  }
                },
                [
                  _c("template", { slot: "extra-info" }, [
                    _vm._v(" m"),
                    _c("sup", [_vm._v("2")])
                  ])
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  name: "leaveArea[number_of_residents]",
                  label:
                    _vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.number_of_residents
                },
                on: {
                  input: function($event) {
                    return _vm.countDependantLeaveAreaPoints(_vm.leaveArea)
                  }
                },
                model: {
                  value: _vm.leaveArea["number_of_residents"],
                  callback: function($$v) {
                    _vm.$set(_vm.leaveArea, "number_of_residents", $$v)
                  },
                  expression: "leaveArea['number_of_residents']"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  name: "leaveArea[total]",
                  label: _vm.totalLabel(
                    _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.leave_area
                  ),
                  isReadonly: true
                },
                model: {
                  value: _vm.leaveArea.total,
                  callback: function($$v) {
                    _vm.$set(_vm.leaveArea, "total", $$v)
                  },
                  expression: "leaveArea.total"
                }
              })
            ],
            1
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-section" }, [
      _c("h2", { staticClass: "calculate-price__form-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.dependant_other_spaces_area
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "grid grid-cols-1 lg:grid-cols-3 gap-x-5 gap-y-5 lg:gap-y-8 items-end"
        },
        [
          _c(
            "div",
            [
              _c(
                "theme-numeric",
                {
                  attrs: {
                    name: "otherSpaces[private_other_spaces][surface]",
                    label:
                      _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.private_other_rooms_surface,
                    IsExtraInfo: true
                  },
                  on: {
                    input: function($event) {
                      return _vm.countDependantOtherSpacesAreaPoints(
                        _vm.otherSpaces
                      )
                    }
                  },
                  model: {
                    value: _vm.otherSpaces["private_other_spaces"].surface,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.otherSpaces["private_other_spaces"],
                        "surface",
                        $$v
                      )
                    },
                    expression: "otherSpaces['private_other_spaces'].surface"
                  }
                },
                [
                  _c("template", { slot: "extra-info" }, [
                    _vm._v(" m"),
                    _c("sup", [_vm._v("2")])
                  ])
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "theme-numeric",
                {
                  attrs: {
                    name: "otherSpaces[common_other_spaces_area][surface]",
                    label:
                      _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties
                        .common_other_spaces_area_at_same_address,
                    IsExtraInfo: true
                  },
                  on: {
                    input: function($event) {
                      return _vm.countDependantOtherSpacesAreaPoints(
                        _vm.otherSpaces
                      )
                    }
                  },
                  model: {
                    value: _vm.otherSpaces["common_other_spaces_area"].surface,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.otherSpaces["common_other_spaces_area"],
                        "surface",
                        $$v
                      )
                    },
                    expression:
                      "otherSpaces['common_other_spaces_area'].surface"
                  }
                },
                [
                  _c("template", { slot: "extra-info" }, [
                    _vm._v(" m"),
                    _c("sup", [_vm._v("2")])
                  ])
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  name: "otherSpaces[number_of_residents]",
                  label:
                    _vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.number_of_residents
                },
                on: {
                  input: function($event) {
                    return _vm.countDependantOtherSpacesAreaPoints(
                      _vm.otherSpaces
                    )
                  }
                },
                model: {
                  value: _vm.otherSpaces["number_of_residents"],
                  callback: function($$v) {
                    _vm.$set(_vm.otherSpaces, "number_of_residents", $$v)
                  },
                  expression: "otherSpaces['number_of_residents']"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  name: "otherSpaces[total]",
                  label: _vm.totalLabel(
                    _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.other_spaces
                  ),
                  isReadonly: true
                },
                model: {
                  value: _vm.otherSpaces.total,
                  callback: function($$v) {
                    _vm.$set(_vm.otherSpaces, "total", $$v)
                  },
                  expression: "otherSpaces.total"
                }
              })
            ],
            1
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-section" }, [
      _c("h2", { staticClass: "calculate-price__form-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.heating_and_cooling
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "grid grid-cols-1 lg:grid-cols-3 gap-x-5 gap-y-5 lg:gap-y-8 items-end"
        },
        [
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  name: "heating[private_rooms_with_heating]",
                  label:
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.private_rooms_with_heating) +
                    " " +
                    (_vm.heating.private_rooms_with_heating.value
                      ? _vm.heating.private_rooms_with_heating.total
                      : ""),
                  IsExtraInfo: true
                },
                on: { input: _vm.countHeatingPoints },
                model: {
                  value: _vm.heating.private_rooms_with_heating.value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.heating.private_rooms_with_heating,
                      "value",
                      $$v
                    )
                  },
                  expression: "heating.private_rooms_with_heating.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  name: "heating[private_rooms_with_cooling]",
                  label:
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.private_rooms_with_cooling) +
                    " " +
                    (_vm.heating.private_rooms_with_cooling.value
                      ? _vm.heating.private_rooms_with_cooling.total
                      : ""),
                  IsExtraInfo: true
                },
                on: { input: _vm.countHeatingPoints },
                model: {
                  value: _vm.heating.private_rooms_with_cooling.value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.heating.private_rooms_with_cooling,
                      "value",
                      $$v
                    )
                  },
                  expression: "heating.private_rooms_with_cooling.value"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "grid grid-cols-1 lg:grid-cols-3 gap-x-5 gap-y-5 lg:gap-y-8 items-end"
        },
        [
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  name: "heating[number_of_residents]",
                  label:
                    "" +
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.number_of_residents),
                  IsExtraInfo: true
                },
                on: { input: _vm.countHeatingPoints },
                model: {
                  value: _vm.heating["number_of_residents"],
                  callback: function($$v) {
                    _vm.$set(_vm.heating, "number_of_residents", $$v)
                  },
                  expression: "heating['number_of_residents']"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  name: "heating[shared_rooms_with_heating]",
                  label:
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.shared_rooms_with_heating) +
                    " " +
                    (_vm.heating.shared_rooms_with_heating.value
                      ? _vm.heating.shared_rooms_with_heating.total
                      : ""),
                  IsExtraInfo: true
                },
                on: { input: _vm.countHeatingPoints },
                model: {
                  value: _vm.heating.shared_rooms_with_heating.value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.heating.shared_rooms_with_heating,
                      "value",
                      $$v
                    )
                  },
                  expression: "heating.shared_rooms_with_heating.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  name: "heating[shared_rooms_with_cooling]",
                  label:
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.shared_rooms_with_cooling) +
                    " " +
                    (_vm.heating.shared_rooms_with_cooling.value
                      ? _vm.heating.shared_rooms_with_cooling.total
                      : ""),
                  IsExtraInfo: true
                },
                on: { input: _vm.countHeatingPoints },
                model: {
                  value: _vm.heating.shared_rooms_with_cooling.value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.heating.shared_rooms_with_cooling,
                      "value",
                      $$v
                    )
                  },
                  expression: "heating.shared_rooms_with_cooling.value"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "grid grid-cols-1 lg:grid-cols-3 gap-x-5 gap-y-5 lg:gap-y-8 items-end"
        },
        [
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  name: "heating[private_other_spaces_with_heating]",
                  label:
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties
                        .private_other_spaces_with_heating) +
                    " " +
                    (_vm.heating.private_other_spaces_with_heating.value
                      ? _vm.heating.private_other_spaces_with_heating.total
                      : ""),
                  IsExtraInfo: true
                },
                on: { input: _vm.countHeatingPoints },
                model: {
                  value: _vm.heating.private_other_spaces_with_heating.value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.heating.private_other_spaces_with_heating,
                      "value",
                      $$v
                    )
                  },
                  expression: "heating.private_other_spaces_with_heating.value"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "grid grid-cols-1 lg:grid-cols-3 gap-x-5 gap-y-5 lg:gap-y-8 items-end"
        },
        [
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  name: "heating[number_of_other_spaces_residents]",
                  label:
                    "" +
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.number_of_residents),
                  IsExtraInfo: true
                },
                on: { input: _vm.countHeatingPoints },
                model: {
                  value: _vm.heating["number_of_other_spaces_residents"],
                  callback: function($$v) {
                    _vm.$set(
                      _vm.heating,
                      "number_of_other_spaces_residents",
                      $$v
                    )
                  },
                  expression: "heating['number_of_other_spaces_residents']"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  name: "heating[shared_other_spaces_with_heating]",
                  label:
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.shared_other_spaces_with_heating) +
                    " " +
                    (_vm.heating.shared_other_spaces_with_heating.value
                      ? _vm.heating.shared_other_spaces_with_heating.total
                      : ""),
                  IsExtraInfo: true
                },
                on: { input: _vm.countHeatingPoints },
                model: {
                  value: _vm.heating.shared_other_spaces_with_heating.value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.heating.shared_other_spaces_with_heating,
                      "value",
                      $$v
                    )
                  },
                  expression: "heating.shared_other_spaces_with_heating.value"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                name: "heating[total]",
                label: _vm.totalLabel(
                  _vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.heated_private_rooms
                ),
                isReadonly: true
              },
              model: {
                value: _vm.heating.total,
                callback: function($$v) {
                  _vm.$set(_vm.heating, "total", $$v)
                },
                expression: "heating.total"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-section" }, [
      _c("h2", { staticClass: "calculate-price__form-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.energy_performance
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mb-10" }, [
        _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.energy_label
              ) +
              "\n        "
          ),
          _vm.energy.energy_label &&
          _vm.energyLabels[_vm.energy.energy_label] &&
          _vm.energyLabels[_vm.energy.energy_label]["slug"] !=
            "no_label_or_index"
            ? _c("strong", [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.energy.energy_points || "") +
                    "\n        "
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mb-10" },
          [
            _c("theme-radios", {
              attrs: {
                name: "energy[energy_label]",
                options: _vm.energyLabelsOptions,
                sort: true,
                "sort-by": "custom",
                "custom-order": _vm.energyLabelsCustomOrder
              },
              on: { input: _vm.countEnergyPoints },
              model: {
                value: _vm.energy.energy_label,
                callback: function($$v) {
                  _vm.$set(_vm.energy, "energy_label", $$v)
                },
                expression: "energy.energy_label"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.energy.energy_label &&
        _vm.energyLabels[_vm.energy.energy_label] &&
        _vm.energyLabels[_vm.energy.energy_label]["slug"] == "no_label_or_index"
          ? _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-12" }, [
              _c(
                "div",
                { staticClass: "col-span-4" },
                [
                  _c("theme-input", {
                    attrs: {
                      label:
                        (_vm.locales &&
                          _vm.locales.properties &&
                          _vm.locales.properties.construction_year) +
                        " " +
                        ((_vm.energy.building_construction_year &&
                          _vm.energy.energy_points) ||
                          ""),
                      name: "energy[building_construction_year]"
                    },
                    on: { input: _vm.countEnergyPoints },
                    model: {
                      value: _vm.energy.building_construction_year,
                      callback: function($$v) {
                        _vm.$set(_vm.energy, "building_construction_year", $$v)
                      },
                      expression: "energy.building_construction_year"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-5" },
        [
          _c("input", {
            attrs: {
              type: "hidden",
              name: "energy[monument_allowance]",
              value: "0"
            }
          }),
          _vm._v(" "),
          _c("theme-checkboxes", {
            attrs: {
              id: "monumentAllowance",
              label: "",
              "is-single-checkbox": true,
              name: "energy[monument_allowance]",
              options: {
                "1":
                  "" +
                  (_vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.monument_allowance_energy)
              }
            },
            on: { input: _vm.countEnergyPoints },
            model: {
              value: _vm.energy.monument_allowance,
              callback: function($$v) {
                _vm.$set(_vm.energy, "monument_allowance", $$v)
              },
              expression: "energy.monument_allowance"
            }
          }),
          _vm._v(" "),
          _vm.energy.monument_allowance == 1
            ? [
                _c("input", {
                  attrs: {
                    type: "hidden",
                    name: "energy[monument_allowance]",
                    value: "1"
                  }
                })
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                "valid-scope": "modal-form",
                name: "energy[total]",
                label:
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.total_energy,
                precision: 2,
                isReadonly: true
              },
              model: {
                value: _vm.energy.total,
                callback: function($$v) {
                  _vm.$set(_vm.energy, "total", $$v)
                },
                expression: "energy.total"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-section" }, [
      _c("h2", { staticClass: "calculate-price__form-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.kitchen
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid grid-cols-1 lg:grid-cols-3 gap-5 mb-10" },
        [
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  name: "kitchen[number_of_residents]",
                  label:
                    "" +
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.number_of_residents),
                  IsExtraInfo: true
                },
                on: { input: _vm.countKitchenPoints },
                model: {
                  value: _vm.kitchen["number_of_residents"],
                  callback: function($$v) {
                    _vm.$set(_vm.kitchen, "number_of_residents", $$v)
                  },
                  expression: "kitchen['number_of_residents']"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid grid-cols-1 lg:grid-cols-3 gap-5 mb-10" },
        [
          _c(
            "div",
            [
              _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.worktop_length
                    ) +
                    "\n          "
                ),
                _vm.kitchen.worktop_length.value
                  ? _c("strong", [
                      _vm._v(_vm._s(_vm.kitchen.worktop_length.total || ""))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("theme-radios", {
                attrs: {
                  columnDirection: true,
                  name: "kitchen[worktop_length]",
                  options: {
                    "1":
                      _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.less_than_1_meter,
                    "2":
                      _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties["1_2_meters"],
                    "3":
                      _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties["2_3_meters"],
                    "4":
                      _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.more_than_3_meters,
                    "5":
                      _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.more_than_5_meters
                  }
                },
                on: { input: _vm.countKitchenPoints },
                model: {
                  value: _vm.kitchen.worktop_length.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchen.worktop_length, "value", $$v)
                  },
                  expression: "kitchen.worktop_length.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.cooker
                    ) +
                    "\n          "
                ),
                _vm.kitchen.cooker.value
                  ? _c("strong", [
                      _vm._v(_vm._s(_vm.kitchen.cooker.total || ""))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("theme-radios", {
                attrs: {
                  columnDirection: true,
                  name: "kitchen[cooker]",
                  options: {
                    "1":
                      _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.built_in_gas_hob,
                    "2":
                      _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.built_in_ceramic_hob,
                    "3":
                      _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.built_in_induction_hob
                  }
                },
                on: { input: _vm.countKitchenPoints },
                model: {
                  value: _vm.kitchen.cooker.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchen.cooker, "value", $$v)
                  },
                  expression: "kitchen.cooker.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.oven
                    ) +
                    "\n          "
                ),
                _vm.kitchen.oven.value
                  ? _c("strong", [_vm._v(_vm._s(_vm.kitchen.oven.total || ""))])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("theme-radios", {
                attrs: {
                  columnDirection: true,
                  name: "kitchen[oven]",
                  options: {
                    "1":
                      _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.built_in_gas_oven,
                    "2":
                      _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.built_in_electric_oven
                  }
                },
                on: { input: _vm.countKitchenPoints },
                model: {
                  value: _vm.kitchen.oven.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchen.oven, "value", $$v)
                  },
                  expression: "kitchen.oven.value"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "mb-10" }, [
        _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-5 gap-5" }, [
          _c(
            "div",
            [
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: "kitchen[built_in_microwave]",
                  value: "0"
                }
              }),
              _vm._v(" "),
              _c("theme-checkboxes", {
                attrs: {
                  id: "built_in_microwave",
                  label: "",
                  "is-single-checkbox": true,
                  name: "kitchen[built_in_microwave]",
                  options: {
                    "1":
                      (_vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.built_in_microwave) +
                      " " +
                      (_vm.kitchen.built_in_microwave.value == 1
                        ? _vm.kitchen.built_in_microwave.total
                        : "")
                  }
                },
                on: { input: _vm.countKitchenPoints },
                model: {
                  value: _vm.kitchen.built_in_microwave.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchen.built_in_microwave, "value", $$v)
                  },
                  expression: "kitchen.built_in_microwave.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: "kitchen[built_in_extractor_hood]",
                  value: "0"
                }
              }),
              _vm._v(" "),
              _c("theme-checkboxes", {
                attrs: {
                  id: "built_in_extractor_hood",
                  label: "",
                  "is-single-checkbox": true,
                  name: "kitchen[built_in_extractor_hood]",
                  options: {
                    "1":
                      (_vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.built_in_extractor_hood) +
                      " " +
                      (_vm.kitchen.built_in_extractor_hood.value == 1
                        ? _vm.kitchen.built_in_extractor_hood.total
                        : "")
                  }
                },
                on: { input: _vm.countKitchenPoints },
                model: {
                  value: _vm.kitchen.built_in_extractor_hood.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchen.built_in_extractor_hood, "value", $$v)
                  },
                  expression: "kitchen.built_in_extractor_hood.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: "kitchen[built_in_fridge]",
                  value: "0"
                }
              }),
              _vm._v(" "),
              _c("theme-checkboxes", {
                attrs: {
                  id: "built_in_fridge",
                  label: "",
                  "is-single-checkbox": true,
                  name: "kitchen[built_in_fridge]",
                  options: {
                    "1":
                      (_vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.built_in_fridge) +
                      " " +
                      (_vm.kitchen.built_in_fridge.value == 1
                        ? _vm.kitchen.built_in_fridge.total
                        : "")
                  }
                },
                on: { input: _vm.countKitchenPoints },
                model: {
                  value: _vm.kitchen.built_in_fridge.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchen.built_in_fridge, "value", $$v)
                  },
                  expression: "kitchen.built_in_fridge.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: "kitchen[built_in_freezer]",
                  value: "0"
                }
              }),
              _vm._v(" "),
              _c("theme-checkboxes", {
                attrs: {
                  id: "built_in_freezer",
                  label: "",
                  "is-single-checkbox": true,
                  name: "kitchen[built_in_freezer]",
                  options: {
                    "1":
                      (_vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.built_in_freezer) +
                      " " +
                      (_vm.kitchen.built_in_freezer.value == 1
                        ? _vm.kitchen.built_in_freezer.total
                        : "")
                  }
                },
                on: { input: _vm.countKitchenPoints },
                model: {
                  value: _vm.kitchen.built_in_freezer.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchen.built_in_freezer, "value", $$v)
                  },
                  expression: "kitchen.built_in_freezer.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: "kitchen[built_in_dishwasher]",
                  value: "0"
                }
              }),
              _vm._v(" "),
              _c("theme-checkboxes", {
                attrs: {
                  id: "built_in_dishwasher",
                  label: "",
                  "is-single-checkbox": true,
                  name: "kitchen[built_in_dishwasher]",
                  options: {
                    "1":
                      (_vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.built_in_dishwasher) +
                      " " +
                      (_vm.kitchen.built_in_dishwasher.value == 1
                        ? _vm.kitchen.built_in_dishwasher.total
                        : "")
                  }
                },
                on: { input: _vm.countKitchenPoints },
                model: {
                  value: _vm.kitchen.built_in_dishwasher.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchen.built_in_dishwasher, "value", $$v)
                  },
                  expression: "kitchen.built_in_dishwasher.value"
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "grid grid-cols-1 lg:grid-cols-4 gap-5 mb-10 items-end"
        },
        [
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "kitchen[luxury_mixer_tap]",
                  label:
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.luxury_mixer_tap) +
                    " " +
                    (_vm.kitchen.luxury_mixer_tap.value
                      ? _vm.kitchen.luxury_mixer_tap.total
                      : ""),
                  precision: 0
                },
                on: { input: _vm.countKitchenPoints },
                model: {
                  value: _vm.kitchen.luxury_mixer_tap.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchen.luxury_mixer_tap, "value", $$v)
                  },
                  expression: "kitchen.luxury_mixer_tap.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "kitchen[thermostatic_water_mixer]",
                  label:
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.thermostatic_water_mixer) +
                    " " +
                    (_vm.kitchen.thermostatic_water_mixer.value
                      ? _vm.kitchen.thermostatic_water_mixer.total
                      : ""),
                  precision: 0
                },
                on: { input: _vm.countKitchenPoints },
                model: {
                  value: _vm.kitchen.thermostatic_water_mixer.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchen.thermostatic_water_mixer, "value", $$v)
                  },
                  expression: "kitchen.thermostatic_water_mixer.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "kitchen[extra_single_cupboard]",
                  label:
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.extra_single_cupboard) +
                    " " +
                    (_vm.kitchen.extra_single_cupboard.value
                      ? _vm.kitchen.extra_single_cupboard.total
                      : ""),
                  precision: 0
                },
                on: { input: _vm.countKitchenPoints },
                model: {
                  value: _vm.kitchen.extra_single_cupboard.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchen.extra_single_cupboard, "value", $$v)
                  },
                  expression: "kitchen.extra_single_cupboard.value"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                "valid-scope": "modal-form",
                name: "kitchen[total]",
                label:
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.total_kitchen,
                precision: 2,
                isReadonly: true
              },
              model: {
                value: _vm.kitchen.total,
                callback: function($$v) {
                  _vm.$set(_vm.kitchen, "total", $$v)
                },
                expression: "kitchen.total"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-section" }, [
      _c("h2", { staticClass: "calculate-price__form-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.sanitary
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid grid-cols-1 lg:grid-cols-3 gap-5 mb-10" },
        [
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  name: "sanitary[number_of_residents]",
                  label:
                    "" +
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.number_of_residents),
                  IsExtraInfo: true
                },
                on: { input: _vm.countSanitaryPoints },
                model: {
                  value: _vm.sanitary["number_of_residents"],
                  callback: function($$v) {
                    _vm.$set(_vm.sanitary, "number_of_residents", $$v)
                  },
                  expression: "sanitary['number_of_residents']"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "grid grid-cols-1 lg:grid-cols-4 gap-5 mb-10 items-end"
        },
        [
          _c(
            "div",
            [
              _c("theme-input", {
                attrs: {
                  label:
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.number_of_toilets) +
                    " " +
                    ((_vm.sanitary.number_of_toilets.value &&
                      _vm.sanitary.number_of_toilets.total) ||
                      ""),
                  name: "sanitary[number_of_toilets]"
                },
                on: { input: _vm.countSanitaryPoints },
                model: {
                  value: _vm.sanitary.number_of_toilets.value,
                  callback: function($$v) {
                    _vm.$set(_vm.sanitary.number_of_toilets, "value", $$v)
                  },
                  expression: "sanitary.number_of_toilets.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.sanitary.number_of_toilets.value > 0
            ? _c(
                "div",
                [
                  _c("theme-input", {
                    attrs: {
                      label:
                        (_vm.locales &&
                          _vm.locales.properties &&
                          _vm.locales.properties.number_of_hunged_toilets) +
                        " " +
                        ((_vm.sanitary.number_of_hunged_toilets.value &&
                          _vm.sanitary.number_of_hunged_toilets.total) ||
                          ""),
                      name: "sanitary[number_of_hunged_toilets]"
                    },
                    on: { input: _vm.countSanitaryPoints },
                    model: {
                      value: _vm.sanitary.number_of_hunged_toilets.value,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.sanitary.number_of_hunged_toilets,
                          "value",
                          $$v
                        )
                      },
                      expression: "sanitary.number_of_hunged_toilets.value"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.sanitary.number_of_toilets.value > 0
            ? _c(
                "div",
                [
                  _c("theme-input", {
                    attrs: {
                      label:
                        (_vm.locales &&
                          _vm.locales.properties &&
                          _vm.locales.properties.number_of_separate_toilets) +
                        " " +
                        ((_vm.sanitary.number_of_separate_toilets.value &&
                          _vm.sanitary.number_of_separate_toilets.total) ||
                          ""),
                      name: "sanitary[number_of_separate_toilets]"
                    },
                    on: { input: _vm.countSanitaryPoints },
                    model: {
                      value: _vm.sanitary.number_of_separate_toilets.value,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.sanitary.number_of_separate_toilets,
                          "value",
                          $$v
                        )
                      },
                      expression: "sanitary.number_of_separate_toilets.value"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-input", {
                attrs: {
                  label:
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.number_of_own_toilets) +
                    " " +
                    ((_vm.sanitary.number_of_own_toilets.value &&
                      _vm.sanitary.number_of_own_toilets.total) ||
                      ""),
                  name: "sanitary[number_of_own_toilets]"
                },
                on: { input: _vm.countSanitaryPoints },
                model: {
                  value: _vm.sanitary.number_of_own_toilets.value,
                  callback: function($$v) {
                    _vm.$set(_vm.sanitary.number_of_own_toilets, "value", $$v)
                  },
                  expression: "sanitary.number_of_own_toilets.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.sanitary.number_of_own_toilets.value > 0
            ? _c(
                "div",
                [
                  _c("theme-input", {
                    attrs: {
                      label:
                        (_vm.locales &&
                          _vm.locales.properties &&
                          _vm.locales.properties.number_of_own_hunged_toilets) +
                        " " +
                        ((_vm.sanitary.number_of_own_hunged_toilets.value &&
                          _vm.sanitary.number_of_own_hunged_toilets.total) ||
                          ""),
                      name: "sanitary[number_of_own_hunged_toilets]"
                    },
                    on: { input: _vm.countSanitaryPoints },
                    model: {
                      value: _vm.sanitary.number_of_own_hunged_toilets.value,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.sanitary.number_of_own_hunged_toilets,
                          "value",
                          $$v
                        )
                      },
                      expression: "sanitary.number_of_own_hunged_toilets.value"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.sanitary.number_of_own_toilets.value > 0
            ? _c(
                "div",
                [
                  _c("theme-input", {
                    attrs: {
                      label:
                        (_vm.locales &&
                          _vm.locales.properties &&
                          _vm.locales.properties
                            .number_of_own_separate_toilets) +
                        " " +
                        ((_vm.sanitary.number_of_own_separate_toilets.value &&
                          _vm.sanitary.number_of_own_separate_toilets.total) ||
                          ""),
                      name: "sanitary[number_of_own_separate_toilets]"
                    },
                    on: { input: _vm.countSanitaryPoints },
                    model: {
                      value: _vm.sanitary.number_of_own_separate_toilets.value,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.sanitary.number_of_own_separate_toilets,
                          "value",
                          $$v
                        )
                      },
                      expression:
                        "sanitary.number_of_own_separate_toilets.value"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-input", {
                attrs: {
                  label:
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.number_of_washbasins) +
                    " " +
                    ((_vm.sanitary.number_of_washbasins.value &&
                      _vm.sanitary.number_of_washbasins.total) ||
                      ""),
                  name: "sanitary[number_of_washbasins]"
                },
                on: { input: _vm.countSanitaryPoints },
                model: {
                  value: _vm.sanitary.number_of_washbasins.value,
                  callback: function($$v) {
                    _vm.$set(_vm.sanitary.number_of_washbasins, "value", $$v)
                  },
                  expression: "sanitary.number_of_washbasins.value"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-10" },
        [
          _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.own_bathroom
                ) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("theme-radios", {
            attrs: {
              label: "",
              name: "sanitary[own_bathroom]",
              options: {
                "0": _vm.locales && _vm.locales.common && _vm.locales.common.no,
                "1": _vm.locales && _vm.locales.common && _vm.locales.common.yes
              }
            },
            on: { input: _vm.countSanitaryPoints },
            model: {
              value: _vm.sanitary.own_bathroom,
              callback: function($$v) {
                _vm.$set(_vm.sanitary, "own_bathroom", $$v)
              },
              expression: "sanitary.own_bathroom"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-10" },
        [
          _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.sanitary
                ) +
                "\n        "
            ),
            _vm.sanitary.shower_bath.value
              ? _c("strong", [
                  _vm._v(_vm._s(_vm.sanitary.shower_bath.total || ""))
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("theme-radios", {
            attrs: {
              label: "",
              name: "sanitary[shower_bath]",
              options: {
                "0":
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.no_shower_or_bath,
                "1":
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.shower_available,
                "2":
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.bath_available,
                "3":
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.separate_bath_and_shower_in_one_room
              }
            },
            on: { input: _vm.countSanitaryPoints },
            model: {
              value: _vm.sanitary.shower_bath.value,
              callback: function($$v) {
                _vm.$set(_vm.sanitary.shower_bath, "value", $$v)
              },
              expression: "sanitary.shower_bath.value"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid grid-cols-1 lg:grid-cols-4 gap-5 mb-10" },
        [
          _c(
            "div",
            [
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: "sanitary[cupboard_with_built_in_washbasin]",
                  value: "0"
                }
              }),
              _vm._v(" "),
              _c("theme-checkboxes", {
                attrs: {
                  id: "cupboard_with_built_in_washbasin",
                  label: "",
                  "is-single-checkbox": true,
                  name: "sanitary[cupboard_with_built_in_washbasin]",
                  options: {
                    "1":
                      (_vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties
                          .cupboard_with_built_in_washbasin) +
                      " " +
                      (_vm.sanitary.cupboard_with_built_in_washbasin.value == 1
                        ? _vm.sanitary.cupboard_with_built_in_washbasin.total
                        : "")
                  }
                },
                on: { input: _vm.countSanitaryPoints },
                model: {
                  value: _vm.sanitary.cupboard_with_built_in_washbasin.value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.sanitary.cupboard_with_built_in_washbasin,
                      "value",
                      $$v
                    )
                  },
                  expression: "sanitary.cupboard_with_built_in_washbasin.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: "sanitary[extra_for_a_bubble_bath]",
                  value: "0"
                }
              }),
              _vm._v(" "),
              _c("theme-checkboxes", {
                attrs: {
                  id: "extra_for_a_bubble_bath",
                  label: "",
                  "is-single-checkbox": true,
                  name: "sanitary[extra_for_a_bubble_bath]",
                  options: {
                    "1":
                      (_vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.extra_for_a_bubble_bath) +
                      " " +
                      (_vm.sanitary.extra_for_a_bubble_bath.value == 1
                        ? _vm.sanitary.extra_for_a_bubble_bath.total
                        : "")
                  }
                },
                on: { input: _vm.countSanitaryPoints },
                model: {
                  value: _vm.sanitary.extra_for_a_bubble_bath.value,
                  callback: function($$v) {
                    _vm.$set(_vm.sanitary.extra_for_a_bubble_bath, "value", $$v)
                  },
                  expression: "sanitary.extra_for_a_bubble_bath.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: "sanitary[mounted_complete_separation_of_shower]",
                  value: "0"
                }
              }),
              _vm._v(" "),
              _c("theme-checkboxes", {
                attrs: {
                  id: "mounted_complete_separation_of_shower",
                  label: "",
                  "is-single-checkbox": true,
                  name: "sanitary[mounted_complete_separation_of_shower]",
                  options: {
                    "1":
                      (_vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties
                          .mounted_complete_separation_of_shower) +
                      " " +
                      (_vm.sanitary.mounted_complete_separation_of_shower
                        .value == 1
                        ? _vm.sanitary.mounted_complete_separation_of_shower
                            .total
                        : "")
                  }
                },
                on: { input: _vm.countSanitaryPoints },
                model: {
                  value:
                    _vm.sanitary.mounted_complete_separation_of_shower.value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.sanitary.mounted_complete_separation_of_shower,
                      "value",
                      $$v
                    )
                  },
                  expression:
                    "sanitary.mounted_complete_separation_of_shower.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: "sanitary[towel_radiator]",
                  value: "0"
                }
              }),
              _vm._v(" "),
              _c("theme-checkboxes", {
                attrs: {
                  id: "towel_radiator",
                  label: "",
                  "is-single-checkbox": true,
                  name: "sanitary[towel_radiator]",
                  options: {
                    "1":
                      (_vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.towel_radiator) +
                      " " +
                      (_vm.sanitary.towel_radiator.value == 1
                        ? _vm.sanitary.towel_radiator.total
                        : "")
                  }
                },
                on: { input: _vm.countSanitaryPoints },
                model: {
                  value: _vm.sanitary.towel_radiator.value,
                  callback: function($$v) {
                    _vm.$set(_vm.sanitary.towel_radiator, "value", $$v)
                  },
                  expression: "sanitary.towel_radiator.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: "sanitary[power_outlet]",
                  value: "0"
                }
              }),
              _vm._v(" "),
              _c("theme-checkboxes", {
                attrs: {
                  id: "power_outlet",
                  label: "",
                  "is-single-checkbox": true,
                  name: "sanitary[power_outlet]",
                  options: {
                    "1":
                      "" +
                      (_vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.power_outlet)
                  }
                },
                on: { input: _vm.countSanitaryPoints },
                model: {
                  value: _vm.sanitary.power_outlet.value,
                  callback: function($$v) {
                    _vm.$set(_vm.sanitary.power_outlet, "value", $$v)
                  },
                  expression: "sanitary.power_outlet.value"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "grid grid-cols-1 lg:grid-cols-4 gap-5 mb-10 items-end"
        },
        [
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "sanitary[luxury_mixer_tap]",
                  label:
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.luxury_mixer_tap) +
                    " " +
                    (_vm.sanitary.luxury_mixer_tap.value
                      ? _vm.sanitary.luxury_mixer_tap.total
                      : ""),
                  precision: 0
                },
                on: { input: _vm.countSanitaryPoints },
                model: {
                  value: _vm.sanitary.luxury_mixer_tap.value,
                  callback: function($$v) {
                    _vm.$set(_vm.sanitary.luxury_mixer_tap, "value", $$v)
                  },
                  expression: "sanitary.luxury_mixer_tap.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "sanitary[thermostatic_water_mixer]",
                  label:
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.thermostatic_water_mixer) +
                    " " +
                    (_vm.sanitary.thermostatic_water_mixer.value
                      ? _vm.sanitary.thermostatic_water_mixer.total
                      : ""),
                  precision: 0
                },
                on: { input: _vm.countSanitaryPoints },
                model: {
                  value: _vm.sanitary.thermostatic_water_mixer.value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.sanitary.thermostatic_water_mixer,
                      "value",
                      $$v
                    )
                  },
                  expression: "sanitary.thermostatic_water_mixer.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.sanitary.power_outlet.value > 0
            ? _c(
                "div",
                [
                  _c("theme-numeric", {
                    attrs: {
                      "valid-scope": "modal-form",
                      name: "sanitary[number_of_power_outlet]",
                      label:
                        (_vm.locales &&
                          _vm.locales.properties &&
                          _vm.locales.properties.number_of_power_outlet) +
                        " " +
                        (_vm.sanitary.number_of_power_outlet.value
                          ? _vm.sanitary.power_outlet.total
                          : ""),
                      precision: 0
                    },
                    on: { input: _vm.countSanitaryPoints },
                    model: {
                      value: _vm.sanitary.number_of_power_outlet.value,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.sanitary.number_of_power_outlet,
                          "value",
                          $$v
                        )
                      },
                      expression: "sanitary.number_of_power_outlet.value"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                "valid-scope": "modal-form",
                name: "sanitary[total]",
                label:
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.total_sanitary,
                precision: 2,
                isReadonly: true
              },
              model: {
                value: _vm.sanitary.total,
                callback: function($$v) {
                  _vm.$set(_vm.sanitary, "total", $$v)
                },
                expression: "sanitary.total"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-section" }, [
      _c("h2", { staticClass: "calculate-price__form-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.housing_for_disabled
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "grid grid-cols-1 lg:grid-cols-4 gap-5 mb-10 items-end"
        },
        [
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "disabled[total_investment]",
                  label:
                    _vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.disabled_total_investment,
                  precision: 2
                },
                on: { input: _vm.countDisabledPoints },
                model: {
                  value: _vm.disabled.total_investment.value,
                  callback: function($$v) {
                    _vm.$set(_vm.disabled.total_investment, "value", $$v)
                  },
                  expression: "disabled.total_investment.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "grid grid-cols-1 lg:grid-cols-3 gap-5 mb-10" },
            [
              _c(
                "div",
                [
                  _c("theme-numeric", {
                    attrs: {
                      name: "disabled[number_of_residents]",
                      label:
                        "" +
                        (_vm.locales &&
                          _vm.locales.properties &&
                          _vm.locales.properties.number_of_residents),
                      IsExtraInfo: true
                    },
                    on: { input: _vm.countDisabledPoints },
                    model: {
                      value: _vm.disabled["number_of_residents"],
                      callback: function($$v) {
                        _vm.$set(_vm.disabled, "number_of_residents", $$v)
                      },
                      expression: "disabled['number_of_residents']"
                    }
                  })
                ],
                1
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                "valid-scope": "modal-form",
                name: "disabled[total]",
                label:
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.total_housing_for_disabled,
                isReadonly: true
              },
              model: {
                value: _vm.disabled.total,
                callback: function($$v) {
                  _vm.$set(_vm.disabled, "total", $$v)
                },
                expression: "disabled.total"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-section" }, [
      _c("h2", { staticClass: "calculate-price__form-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.private_outdoor_space
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid grid-cols-1 lg:grid-cols-3 gap-5 mb-10" },
        [
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "outdoor[private_space_area]",
                  label:
                    "" +
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.private_outdoor_space),
                  precision: 2
                },
                on: { input: _vm.countOutdoorPoints },
                model: {
                  value: _vm.outdoor.private_space_area.value,
                  callback: function($$v) {
                    _vm.$set(_vm.outdoor.private_space_area, "value", $$v)
                  },
                  expression: "outdoor.private_space_area.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "outdoor[common_space_area]",
                  label:
                    "" +
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.common_outdoor_space),
                  precision: 2
                },
                on: { input: _vm.countOutdoorPoints },
                model: {
                  value: _vm.outdoor.common_space_area.value,
                  callback: function($$v) {
                    _vm.$set(_vm.outdoor.common_space_area, "value", $$v)
                  },
                  expression: "outdoor.common_space_area.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "outdoor[common_space_addresses]",
                  label:
                    "" +
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.common_outdoor_space_addresses),
                  precision: 0
                },
                on: { input: _vm.countOutdoorPoints },
                model: {
                  value:
                    _vm.outdoor.common_outdoor_space_for_multiple_addresses
                      .common_space_addresses,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.outdoor.common_outdoor_space_for_multiple_addresses,
                      "common_space_addresses",
                      $$v
                    )
                  },
                  expression:
                    "outdoor.common_outdoor_space_for_multiple_addresses.common_space_addresses"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  name: "outdoor[number_of_residents]",
                  label:
                    "" +
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.number_of_residents),
                  IsExtraInfo: true
                },
                on: { input: _vm.countOutdoorPoints },
                model: {
                  value: _vm.outdoor.common_space_area.number_of_residents,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.outdoor.common_space_area,
                      "number_of_residents",
                      $$v
                    )
                  },
                  expression: "outdoor.common_space_area.number_of_residents"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid grid-cols-1 lg:grid-cols-3 gap-5 mb-10" },
        [
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "outdoor[common_outdoor_space_for_multiple_addresses]",
                  label:
                    "" +
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties
                        .common_outdoor_space_for_multiple_addresses),
                  precision: 2
                },
                on: { input: _vm.countOutdoorPoints },
                model: {
                  value:
                    _vm.outdoor.common_outdoor_space_for_multiple_addresses
                      .value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.outdoor.common_outdoor_space_for_multiple_addresses,
                      "value",
                      $$v
                    )
                  },
                  expression:
                    "outdoor.common_outdoor_space_for_multiple_addresses.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "outdoor[common_outdoor_space_addresses]",
                  label:
                    "" +
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.common_space_addresses),
                  precision: 0
                },
                on: { input: _vm.countOutdoorPoints },
                model: {
                  value:
                    _vm.outdoor.common_outdoor_space_for_multiple_addresses
                      .common_space_addresses,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.outdoor.common_outdoor_space_for_multiple_addresses,
                      "common_space_addresses",
                      $$v
                    )
                  },
                  expression:
                    "outdoor.common_outdoor_space_for_multiple_addresses.common_space_addresses"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  name: "outdoor[number_of_residents]",
                  label:
                    "" +
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.number_of_residents),
                  IsExtraInfo: true
                },
                on: { input: _vm.countOutdoorPoints },
                model: {
                  value: _vm.outdoor["number_of_residents"],
                  callback: function($$v) {
                    _vm.$set(_vm.outdoor, "number_of_residents", $$v)
                  },
                  expression: "outdoor['number_of_residents']"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                "valid-scope": "modal-form",
                name: "outdoor[total]",
                label:
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.total_outdoor,
                isReadonly: true
              },
              model: {
                value: _vm.outdoor.total,
                callback: function($$v) {
                  _vm.$set(_vm.outdoor, "total", $$v)
                },
                expression: "outdoor.total"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-section" }, [
      _c("h2", { staticClass: "calculate-price__form-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.shared_indoor_space
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid grid-cols-1 lg:grid-cols-3 gap-5 mb-10" },
        [
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "indoor[common_departure]",
                  label:
                    "" +
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.common_departure),
                  precision: 2
                },
                on: { input: _vm.countIndoorPoints },
                model: {
                  value: _vm.indoor.common_departure.value,
                  callback: function($$v) {
                    _vm.$set(_vm.indoor.common_departure, "value", $$v)
                  },
                  expression: "indoor.common_departure.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  name: "indoor[number_of_addresses]",
                  label:
                    "" +
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.common_indoor_space_addresses),
                  IsExtraInfo: true
                },
                on: { input: _vm.countIndoorPoints },
                model: {
                  value: _vm.indoor.common_departure.number_of_addresses,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.indoor.common_departure,
                      "number_of_addresses",
                      $$v
                    )
                  },
                  expression: "indoor.common_departure.number_of_addresses"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid grid-cols-1 lg:grid-cols-3 gap-5 mb-10" },
        [
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "indoor[common_other_space]",
                  label:
                    "" +
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.common_other_space),
                  precision: 2
                },
                on: { input: _vm.countIndoorPoints },
                model: {
                  value: _vm.indoor.common_other_space.value,
                  callback: function($$v) {
                    _vm.$set(_vm.indoor.common_other_space, "value", $$v)
                  },
                  expression: "indoor.common_other_space.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "indoor[common_other_space_addresses]",
                  label:
                    "" +
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.common_other_space_addresses),
                  precision: 0
                },
                on: { input: _vm.countIndoorPoints },
                model: {
                  value:
                    _vm.indoor.common_other_space.common_other_space_addresses,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.indoor.common_other_space,
                      "common_other_space_addresses",
                      $$v
                    )
                  },
                  expression:
                    "indoor.common_other_space.common_other_space_addresses"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                "valid-scope": "modal-form",
                name: "outdoor[total]",
                label:
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.total_indoor,
                isReadonly: true
              },
              model: {
                value: _vm.outdoor.total,
                callback: function($$v) {
                  _vm.$set(_vm.outdoor, "total", $$v)
                },
                expression: "outdoor.total"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-section" }, [
      _c("h2", { staticClass: "calculate-price__form-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.shared_parking
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-10" },
        [
          _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.shared_parking
                ) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("theme-radios", {
            attrs: {
              name: "shared_parking[type]",
              options: _vm.sharedParkingOptions
            },
            on: { input: _vm.countSharedParkingPoints },
            model: {
              value: _vm.sharedParking.type,
              callback: function($$v) {
                _vm.$set(_vm.sharedParking, "type", $$v)
              },
              expression: "sharedParking.type"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-4 mb-10" }, [
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                "valid-scope": "modal-form",
                name: "shared_parking[number_of_addresses]",
                label:
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.number_of_addresses
              },
              on: { input: _vm.countSharedParkingPoints },
              model: {
                value: _vm.sharedParking.number_of_addresses,
                callback: function($$v) {
                  _vm.$set(_vm.sharedParking, "number_of_addresses", $$v)
                },
                expression: "sharedParking.number_of_addresses"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                "valid-scope": "modal-form",
                name: "shared_parking[total]",
                label:
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.total_shared_parking,
                isReadonly: true
              },
              model: {
                value: _vm.sharedParking.total,
                callback: function($$v) {
                  _vm.$set(_vm.sharedParking, "total", $$v)
                },
                expression: "sharedParking.total"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-section" }, [
      _c("h2", { staticClass: "calculate-price__form-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.vop
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3 mb-10" }, [
        _c(
          "div",
          [
            _c(
              "a",
              {
                attrs: {
                  target: "_blank",
                  href: "https://www.wozwaardeloket.nl"
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.locales &&
                      _vm.locales.common &&
                      _vm.locales.common.check_here
                  )
                )
              ]
            ),
            _vm._v(" "),
            _c("theme-numeric", {
              attrs: {
                "valid-scope": "modal-form",
                name: "vop[price]",
                label:
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.enter_vop
              },
              on: { input: _vm.countVopPoints },
              model: {
                value: _vm.vop.price.value,
                callback: function($$v) {
                  _vm.$set(_vm.vop.price, "value", $$v)
                },
                expression: "vop.price.value"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "a",
              {
                attrs: {
                  target: "_blank",
                  href:
                    _vm.dependantSettings.price_points_settings
                      .average_vop_prices_link
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.locales &&
                      _vm.locales.common &&
                      _vm.locales.common.check_here
                  )
                )
              ]
            ),
            _vm._v(" "),
            _c("theme-numeric", {
              attrs: {
                "valid-scope": "modal-form",
                name: "vop[average_price]",
                label:
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.average_price_per_m2
              },
              on: { input: _vm.countVopPoints },
              model: {
                value: _vm.vop.average_price,
                callback: function($$v) {
                  _vm.$set(_vm.vop, "average_price", $$v)
                },
                expression: "vop.average_price"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                "valid-scope": "modal-form",
                name: "vop[surface]",
                label:
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.surface
              },
              on: { input: _vm.countVopPoints },
              model: {
                value: _vm.vop.surface,
                callback: function($$v) {
                  _vm.$set(_vm.vop, "surface", $$v)
                },
                expression: "vop.surface"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                "valid-scope": "modal-form",
                name: "vop[total]",
                label:
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.total_vop,
                isReadonly: true
              },
              model: {
                value: _vm.vop.total,
                callback: function($$v) {
                  _vm.$set(_vm.vop, "total", $$v)
                },
                expression: "vop.total"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-section" }, [
      _c("h2", { staticClass: "calculate-price__form-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.extra_points
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mb-10" }, [
        _c(
          "div",
          { staticClass: "col-span-6" },
          [
            _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.care_home
                  ) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("input", {
              attrs: {
                type: "hidden",
                name: "extra_points[care_home]",
                value: "0"
              }
            }),
            _vm._v(" "),
            _c("theme-checkboxes", {
              attrs: {
                id: "careHome",
                label: "",
                "is-single-checkbox": true,
                name: "extra_points[care_home]",
                options: {
                  "1":
                    "" +
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.care_home)
                }
              },
              on: { input: _vm.countExtraPoints },
              model: {
                value: _vm.extraPoints.care_home,
                callback: function($$v) {
                  _vm.$set(_vm.extraPoints, "care_home", $$v)
                },
                expression: "extraPoints.care_home"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-10" },
        [
          _c("input", {
            attrs: {
              type: "hidden",
              name: "extra_points[has_automatic_bell]",
              value: "0"
            }
          }),
          _vm._v(" "),
          _c("theme-checkboxes", {
            attrs: {
              id: "careHomeBell",
              label: "",
              "is-single-checkbox": true,
              name: "extra_points[has_automatic_bell]",
              options: {
                "1":
                  "" +
                  (_vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.has_automatic_bell)
              }
            },
            on: { input: _vm.countExtraPoints },
            model: {
              value: _vm.extraPoints.has_automatic_bell,
              callback: function($$v) {
                _vm.$set(_vm.extraPoints, "has_automatic_bell", $$v)
              },
              expression: "extraPoints.has_automatic_bell"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-10" },
        [
          _c("input", {
            attrs: {
              type: "hidden",
              name: "extra_points[has_charging_station]",
              value: "0"
            }
          }),
          _vm._v(" "),
          _c("theme-checkboxes", {
            attrs: {
              id: "chargingStation",
              label: "",
              "is-single-checkbox": true,
              name: "extra_points[has_charging_station]",
              options: {
                "1":
                  "" +
                  (_vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.has_charging_station)
              }
            },
            on: { input: _vm.countExtraPoints },
            model: {
              value: _vm.extraPoints.has_charging_station,
              callback: function($$v) {
                _vm.$set(_vm.extraPoints, "has_charging_station", $$v)
              },
              expression: "extraPoints.has_charging_station"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-10" },
        [
          _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.national_monument
                ) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("theme-radios", {
            attrs: {
              columnDirection: true,
              name: "extra_points[type]",
              options: {
                "0":
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.municipal_or_provincial_monument,
                "1":
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.protected_town_and_village_view,
                "2":
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.national_monument_before,
                "3":
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.national_monument_after
              }
            },
            on: { input: _vm.countExtraPoints },
            model: {
              value: _vm.extraPoints.national_monument.value,
              callback: function($$v) {
                _vm.$set(_vm.extraPoints.national_monument, "value", $$v)
              },
              expression: "extraPoints.national_monument.value"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                name: "extra_points[total]",
                label: _vm.totalLabel(
                  _vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.extra_points
                ),
                isReadonly: true
              },
              model: {
                value: _vm.extraPoints.total,
                callback: function($$v) {
                  _vm.$set(_vm.extraPoints, "total", $$v)
                },
                expression: "extraPoints.total"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "calculate-price__form-section" },
      [
        _c("h2", { staticClass: "calculate-price__form-title" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.deduction_points
              ) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _vm._l(_vm.deductionOptions, function(deduction, index) {
          return _c("div", { staticClass: "mb-10" }, [
            index != "total"
              ? _c(
                  "div",
                  { key: index, staticClass: "mb-7" },
                  [
                    _c("input", {
                      attrs: {
                        type: "hidden",
                        name: "deduction_points[" + index + "]",
                        value: "0"
                      }
                    }),
                    _vm._v(" "),
                    _c("theme-checkboxes", {
                      attrs: {
                        id: "deductionOptions" + index,
                        label: "",
                        "is-single-checkbox": true,
                        name: "deduction_points[" + index + "]",
                        options: {
                          "1":
                            (_vm.locales &&
                              _vm.locales.properties &&
                              _vm.locales.properties[index]) +
                            " " +
                            (_vm.deductionOptions[index].total || "")
                        }
                      },
                      on: { input: _vm.countDeductionPoints },
                      model: {
                        value: _vm.deductionOptions[index].value,
                        callback: function($$v) {
                          _vm.$set(_vm.deductionOptions[index], "value", $$v)
                        },
                        expression: "deductionOptions[index].value"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        }),
        _vm._v(" "),
        _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  name: "deduction_points[total]",
                  label: _vm.totalLabel(
                    _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.deduction_points_total
                  ),
                  isReadonly: true
                },
                model: {
                  value: _vm.deductionOptions.total,
                  callback: function($$v) {
                    _vm.$set(_vm.deductionOptions, "total", $$v)
                  },
                  expression: "deductionOptions.total"
                }
              })
            ],
            1
          )
        ])
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-bottom" }, [
      _c(
        "div",
        {
          staticClass:
            "default-content grid grid-cols-1 lg:grid-cols-12 items-center gap-1 lg:gap-5"
        },
        [
          _c("div", { staticClass: "col-span-2 hidden lg:block" }, [
            _c("h3", { staticClass: "calculate-price__form-bottom-title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    this.locales &&
                      this.locales.common &&
                      this.locales.common.total
                  ) +
                  "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "lg:col-span-7" }, [
            _c("div", { staticClass: "grid grid-cols-2 items-center gap-5" }, [
              _c(
                "div",
                {
                  staticClass:
                    "grid lg:grid-cols-2 items-center gap-1 lg:gap-5 lg:pr-6"
                },
                [
                  _c(
                    "div",
                    { staticClass: "calculate-price__form-bottom-label" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.locales &&
                            _vm.locales.properties &&
                            _vm.locales.properties.total_points
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "lg:hidden" }, [
                    _vm._v(_vm._s(_vm.totalPoints || "0"))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "hidden lg:block" },
                    [
                      _c("theme-numeric", {
                        attrs: { name: "total", label: "", isReadonly: true },
                        model: {
                          value: _vm.totalPoints,
                          callback: function($$v) {
                            _vm.totalPoints = $$v
                          },
                          expression: "totalPoints"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "grid lg:grid-cols-2 items-center gap-1 lg:gap-5 lg:pr-6"
                },
                [
                  _c(
                    "div",
                    { staticClass: "calculate-price__form-bottom-label" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.locales &&
                            _vm.locales.properties &&
                            _vm.locales.properties.max_basic_rent_price
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "lg:hidden" }, [
                    _vm._v(_vm._s(_vm.price || "0"))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "hidden lg:block" },
                    [
                      _c("theme-numeric", {
                        attrs: { name: "price", label: "", isReadonly: true },
                        model: {
                          value: _vm.price,
                          callback: function($$v) {
                            _vm.price = $$v
                          },
                          expression: "price"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "lg:col-span-3 grid grid-cols-2 items-center gap-5"
            },
            [
              _c(
                "button",
                {
                  staticClass: "theme-btn theme-btn--theme",
                  attrs: { type: "submit" }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.locales &&
                          _vm.locales.common &&
                          _vm.locales.common.download_pdf
                      ) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "theme-btn theme-btn--theme",
                  attrs: { type: "submit", name: "submit", value: "save" }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.locales &&
                          _vm.locales.common &&
                          _vm.locales.common.save
                      ) +
                      "\n        "
                  )
                ]
              )
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06f978a8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06f978a8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/DependantFormNew.vue
// module id = 789
// module chunks = 1